import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	addPrioritySchemeTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.modal-view.add-priority-scheme-title',
		defaultMessage: 'Add priority scheme',
		description: 'Add priority scheme modal title',
	},
	editPrioritySchemeTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.modal-view.edit-priority-scheme-title',
		defaultMessage: 'Edit priority scheme',
		description: 'Edit priority scheme modal title',
	},
	detailsPrioritySchemeTab: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.modal-view.details-priority-scheme-tab',
		defaultMessage: 'Details',
		description: 'details tab title for priority scheme modal',
	},
	projectsPrioritySchemeTab: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.modal-view.projects-priority-scheme-tab',
		defaultMessage: 'Projects',
		description: 'projects tab title for priority scheme modal',
	},
	cancelPrioritySchemeButtonTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.modal-view.cancel-priority-scheme-button-title',
		defaultMessage: 'Cancel',
		description: 'button title for closing priority scheme modal',
	},
	addPrioritySchemeButtonTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.modal-view.add-priority-scheme-button-title',
		defaultMessage: 'Add scheme',
		description: 'button title for adding a new priority scheme via modal',
	},
	editPrioritySchemeButtonTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.modal-view.edit-priority-scheme-button-title',
		defaultMessage: 'Save',
		description: 'button title for editing an existing priority scheme via modal',
	},
	closeModalButtonLabel: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.modal-view.close-modal-button-label',
		defaultMessage: 'Close modal',
		description: 'icon label used for cross icon used for closing priority scheme modal',
	},
});

export default messages;
